import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'video']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "video")[]
 * }>} VideoStyles
 */
export const videoStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.Video} args.component - Video component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {VideoStyles} - Component styles
   */
  baseStyle: ({component}) => {
    return {
      root: {},
      video: {},
    };
  },
});
